import { useEffect, useRef } from "react";

import { acquireSocket, releaseSocket } from "../socket/socket";

function readAccessToken() {
   if (typeof document === "undefined") return "";
   const match = document.cookie.match(/(?:^|;\s*)access_token=([^;]+)/);
   return match ? decodeURIComponent(match[1]) : "";
}

// onMessage: mesaj nou (chat:message). Opțional: onUpdate — mesaj editat / șters
// (chat:message:update), onReceipt — bifele „livrat” / „citit” (chat:receipt).
export default function useChatSocket(enabled, onMessage, { onUpdate, onReceipt } = {}) {
   const handlerRef = useRef(onMessage);
   handlerRef.current = onMessage;
   const updateRef = useRef(onUpdate);
   updateRef.current = onUpdate;
   const receiptRef = useRef(onReceipt);
   receiptRef.current = onReceipt;

   useEffect(() => {
      if (!enabled) return undefined;

      const token = readAccessToken();
      if (!token) return undefined;

      const socket = acquireSocket(token);
      if (!socket) return undefined;

      const register = () => {
         try {
            socket.emit("register");
         } catch {}
      };

      const handleChatMessage = (payload) => {
         try {
            handlerRef.current?.(payload);
         } catch {}
      };

      const handleChatUpdate = (payload) => {
         try {
            updateRef.current?.(payload);
         } catch {}
      };

      const handleChatReceipt = (payload) => {
         try {
            receiptRef.current?.(payload);
         } catch {}
      };

      socket.on("connect", register);
      socket.on("chat:message", handleChatMessage);
      socket.on("chat:message:update", handleChatUpdate);
      socket.on("chat:receipt", handleChatReceipt);
      if (socket.connected) register();

      return () => {
         socket.off("connect", register);
         socket.off("chat:message", handleChatMessage);
         socket.off("chat:message:update", handleChatUpdate);
         socket.off("chat:receipt", handleChatReceipt);
         releaseSocket();
      };
   }, [enabled]);
}
